export default __webpack_public_path__ + "static/vtu-d10cca9ec57cdb7fe5c3b317c2c032df.jpg";